export default __webpack_public_path__ + "static/media/pic27.27155372.jpg";